{
  "todayButton": "Σήμερα",
  "nextMonth": "Επόμενος μήνας",
  "previousMonth": "Προηγούμενος μήνας",
  "nextYear": "Επόμενος χρόνος",
  "previousYear": "Προηγούμενος χρόνος",
  "weekdays": [
    "Κυριακή",
    "Δευτέρα",
    "Τρίτη",
    "Τετάρτη",
    "Πέμπτη",
    "Παρασκευή",
    "Σάββατο"
  ],
  "months": [
    "Ιανουάριος",
    "Φεβρουάριος",
    "Μάρτιος",
    "Απρίλιος",
    "Μάιος",
    "Ιούνιος",
    "Ιούλιος",
    "Αύγουστος",
    "Σεπτέμβριος",
    "Οκτώβριος",
    "Νοέμβριος",
    "Δεκέμβριος"
  ]
}
